module.exports = __webpack_public_path__ + "static/media/chat_green.a0984200.svg";